export interface SegmentSimWarningDataModel {
  segmentId: string
  countryCode: string
  warningName: string
  latitude: number
  longitude: number
  ttl: number
  class: string
  targets: string[] | null | undefined
  direction: string
  bidirectional: boolean
  isCancelled: boolean
  traceId?: string
  confidence?: number
  dfrsClassification?: 'DFRS_ONLY' | 'DFRS_PARTLY' | 'DFRS_NONE'
  valid?: boolean
}

export interface AreaSimWarningDataModel {
  warningName: string
  latitude: number
  longitude: number
  ttl: number
  targets: string[] | null | undefined
  h3id: string
  countryCode: string
  isCancelled: boolean
  traceId?: string
  confidence?: number
  dfrsClassification?: 'DFRS_ONLY' | 'DFRS_PARTLY' | 'DFRS_NONE'
  valid?: boolean
}

export type SimWarningDataModel = (SegmentSimWarningDataModel | AreaSimWarningDataModel) & {
  featureId?: string
}

export function isSegmentSimWarningDataModel(
  warning: SegmentSimWarningDataModel | AreaSimWarningDataModel | undefined,
): warning is SegmentSimWarningDataModel {
  return warning !== undefined && 'segmentId' in warning
}

export function isAreaSimWarningDataModel(
  warning: SegmentSimWarningDataModel | AreaSimWarningDataModel | undefined,
): warning is AreaSimWarningDataModel {
  return warning !== undefined && 'h3id' in warning
}

export interface SimWarningValidationResult {
  isValid: boolean
  id: string
}
